import { render, staticRenderFns } from "./gardenProfitInfo.vue?vue&type=template&id=50f64d34&"
import script from "./gardenProfitInfo.vue?vue&type=script&lang=js&"
export * from "./gardenProfitInfo.vue?vue&type=script&lang=js&"
import style0 from "./gardenProfitInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports